<template>
	<section v-if="items.length" class="promotions align-center">
		<slot name="blocks-header" />
		<div class="row">
			<div
				v-for="(block, index) in items.slice(0, amount)"
				:key="block.ID"
				class="columns column4 fade-animate fade-up"
				:class="'delay-' + index"
			>
				<div class="promotion">
					<div class="image">
						<picture>
							<source :srcset="block.imageWebp" type="image/webp" />
							<source :srcset="block.image" />
							<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
						</picture>
					</div>
					<div class="content">
						<h4>
							<nuxt-link :to="block.link">
								{{ block.header }}
							</nuxt-link>
						</h4>
						<div class="content-slide">
							<div v-parse-links v-html="block.content" />
						</div>
						<nuxt-link :to="block.link" class="button no-fill" target="_self">
							{{ $t('readMore') }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
		<div class="fine-bg-pattern" />
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 4 },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
	position: relative;
	z-index: 2;
}

.promotions {
	position: relative;

	.columns {
		display: flex;
	}

	.button {
		border-color: #fff;
		color: #fff;

		&:hover {
			border-color: var(--cta-color-hover);
		}
	}
}

.fine-bg-pattern {
	position: absolute;
	inset: 60% 0 0;
	width: 100%;
	z-index: 1;
}

.promotion {
	background-color: var(--primary-background-color);
	margin: 0 auto 20px;
	position: relative;
	overflow: hidden;
	width: 100%;

	.content {
		background: none;
		position: absolute;
		bottom: 30px;
		left: 30px;
		right: 30px;
		z-index: 3;
		padding: 0 10px;
		color: #fff;

		h4 {
			margin: 0 0 20px;

			a {
				text-decoration: none;
				color: #fff;
			}
		}

		.content-slide {
			overflow: hidden;

			p,
			:deep(p) {
				height: 0;
				opacity: 0;
				margin: 0;
				transition: all 0.3s ease-in-out;
			}
		}
	}

	.image {
		display: block;
		overflow: hidden;
		position: relative;
		border-radius: 20px;

		&::before {
			content: '';
			display: block;
			position: absolute;
			inset: 0;
			background: rgb(0 0 0 / 20%);
			z-index: 2;
		}

		img {
			transition: all 0.3s ease-in-out;
			background: #000;
			z-index: 1;
			position: relative;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	&:hover {
		.content {
			.content-slide {
				p,
				:deep(p) {
					opacity: 1;
					height: 140px;
					margin: 0 0 20px;
				}
			}
		}
	}
}

@media (max-width: 580px) {
	.promotion {
		.content {
			text-align: left;
			bottom: 120px;

			.content-slide {
				p,
				:deep(p) {
					height: auto !important;
					opacity: 1;
					margin: 0 0 30px !important;
				}
			}
		}
	}
}
</style>
